import LoopIcon from '@mui/icons-material/Loop';
import EventIcon from '@mui/icons-material/Event';
import { CustomConfirmDialog } from '../../../components/CustomConfirmDialog';

type RenewalChoiceDialogProps = {
  variant: 'certification' | 'security-inventory';
  open: boolean;
  onClose: () => void;
  onRenewNow: () => void;
  onPlanRenewal: () => void;
};

export const RenewalChoiceDialog = (props: RenewalChoiceDialogProps) => {

  let dialogTitle: string;
  let dialogSubTitle: string;
  let renewNowTitle: string;
  let planRenewalTitle: string;
  if (props.variant === 'certification') {

    dialogTitle = 'resources.assets.certifications.text.choice_dialog_title';
    dialogSubTitle = 'resources.assets.certifications.text.choice_dialog_subtitle';
    renewNowTitle = 'resources.assets.certifications.text.renew_now';
    planRenewalTitle = 'resources.assets.certifications.text.plan_renewal';

  } else {

    dialogTitle = 'resources.security-inventory-items.text.choice_dialog_title';
    dialogSubTitle = 'resources.security-inventory-items.text.choice_dialog_subtitle';
    renewNowTitle = 'resources.security-inventory-items.text.renew_now';
    planRenewalTitle = 'resources.security-inventory-items.text.plan_renewal';

  }

  return (
    <CustomConfirmDialog
      open={props.open}
      handleClose={props.onClose}
      dialogTitle={dialogTitle}
      dialogSubTitle={dialogSubTitle}
      icon1={{
        title: renewNowTitle,
        subTitle: '',
        action: props.onRenewNow,
        icon: <LoopIcon />,
      }}
      icon2={{
        title: planRenewalTitle,
        subTitle: '',
        action: props.onPlanRenewal,
        icon: <EventIcon />,
      }}
    />
  );

};
